import React from 'react';

export default function AppAdminPublicTeamsListItem({team}) 
{
    var CreatedDT = new Date(team.CreatedAt);

    const formattedDate = CreatedDT.toLocaleString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

    var pill = <></>;
    if (team.NumMembers > 1) pill = <span class="badge bg-primary rounded-pill">{team.NumMembers}</span>

    return (
        <>
            <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                    <div><b>{team.TeamName}</b> <small>({team.CreatedBy})</small></div>
                    <div><small><i>since {formattedDate}</i></small></div>
                    <small>{team.TotalNumFiles} Files, {team.TotalStorageUsedMB} MB used of {team.MaxStorageMB} MB limit</small>
                </div>
                {pill}
            </li>
        </>
    );
}
